import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AngularFirestoreCollection, AngularFirestore } from '@angular/fire/firestore';
import { Incidence } from '../models/incidence.model';
import { map } from 'rxjs/operators';
import { firestore, database } from 'firebase';
import { UserService } from '../core/user.service';
import { AngularFireStorage } from '@angular/fire/storage';


@Injectable({
  providedIn: 'root'
})
export class IncidentsService {
  private collection: AngularFirestoreCollection<Incidence>;

  public incidentTypes: Array<any>;


  constructor(
    private db: AngularFirestore,
    private http: HttpClient,
    private userService: UserService,
    private storage: AngularFireStorage
  ) { 
    this.collection = this.db.collection<Incidence>('incidences', ref=> ref.orderBy('createdAt', 'desc'));
  }


  async loadData(){
    this.incidentTypes = await this.http.get<any>('./assets/data/incidents-type.json').toPromise();
    /* QUITADOS DE MOMENTO
    *,
      {
        "id": "11",
        "name": "INCIDENT_TYPE.BRAKE_FLUID",
        "image":"thief-car-icon.png"
      },
      {
        "id": "12",
        "name": "INCIDENT_TYPE.BROKEN_MIRROR",
        "image":"thief-car-icon.png"
      }
    */
  }

  getAll() {
    return this.collection.snapshotChanges().pipe(
      map(actions => actions.map(a => {
        const data = a.payload.doc.data() as Incidence;
        const id = a.payload.doc.id;
        return {id,  ...data };
      }))
    )
  }

  delete(id: string){
    return this.collection.doc<Incidence>(id).delete();
  }

  upsert(data): Promise<any>{
    const id = data.id;
    delete data.id;
    
    if(!id){
      data.idSender = this.userService.userG.id,
      data.sender = this.userService.userG.displayName;
      data.createdAt = firestore.FieldValue.serverTimestamp();
    }
    data.updatedAt = firestore.FieldValue.serverTimestamp();

    return (id)
      ? this.collection.doc(id).update(data)
      : this.collection.add(data);
  }  

  create(data, image?, type?): Promise<any>{
    data.idSender = this.userService.userG.id,
    data.sender = this.userService.userG.displayName;
    data.createdAt = firestore.FieldValue.serverTimestamp();

    const id = this.db.createId();

    return Promise.resolve()
      .then(_=>{
        if(image){
          const filePath = `incidences/${id}/${data.idSender}.${type}`;
          return this.storage.ref(filePath).putString(image, 'data_url', {contentType: `image/${type}`})
          .then(res => res.ref.getDownloadURL());          
        } else return null;
      })
      .then(path=>{
        if(path) data.picture=path;
        return this.collection.doc(id).set(data, { merge: true })
      })
  }

  getIncidences(id) {
    console.log('id', id);
    const qry = this.db.collection<Incidence>('incidences', ref=> 
      ref.where('idSender','==', id)
      .orderBy('createdAt', 'desc'));
    return qry.snapshotChanges().pipe(
      map(actions => actions.map(a => {
        const data = a.payload.doc.data() as Incidence;
        const id = a.payload.doc.id;
        return {id,  ...data };
      }))
    )
  }  
}
